import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import useApi from "../../Hooks/useApi";
import * as api from "../../api/getapi";
import * as postapi from "../../api/postapi";
import SearchableSelect from "../../Components/SearchableSelect";

function DeliveryPartnerModal({ toggle, close, deliveryPartnersData, edit }) {
  const [validated, setValidated] = useState(false);
  const [error, setError] = useState("");
  const [customForm, setCustomForm] = useState({
    name: "",
    type: "",
    tracking_url: "",
  });

  const savePartner = useApi(postapi.addDeliveryPartner, { hasCatchError: true });
  const updatePartner = useApi(postapi.updateDeliveryPartner, { hasCatchError: true });

  const handleChange = (e) => {
    setCustomForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (!form.checkValidity()) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    setValidated(true);
    let obj = {
      name: customForm.name?.label,
      type: customForm.type?.label,
      tracking_url: customForm.tracking_url,
    };
    try {
      let res;
      if (edit) {
        res = await updatePartner.request(obj, deliveryPartnersData?.id);
      } else {
        res = await savePartner.request(obj);
      }
      setValidated(false);
      setCustomForm({
        name: "",
        type: "",
        tracking_url: "",
      });
      toggle((prev) => !prev);
      close();
      setError("");
    } catch (error) {
      console.log("error", error);
      setError(error.response.data.error);
    }
  };
  const handleSelectChange = (e, name) => {
    setCustomForm((prev) => ({ ...prev, [name]: e }));
  };

  useEffect(() => {
    if (edit) {
      setCustomForm({
        name: { label: deliveryPartnersData?.name || "", value: deliveryPartnersData?.name || "" },
        type: { label: deliveryPartnersData?.type || "", value: deliveryPartnersData?.type || "" },
        tracking_url: deliveryPartnersData?.tracking_url || "",
      });
    } else {
      setCustomForm({
        name: "",
        type: "",
        tracking_url: "",
      });
    }
  }, [edit]);
  return (
    <div>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        {error && <span className="text-danger p-2 text-center my-2 rounded-1">*{error}</span>}

        <Row className="">
          <Col className="py-3" md={6}>
            <Form.Group>
              <SearchableSelect
                placeholder="Select"
                label="Name "
                important={true}
                value={customForm.name}
                searchable={false}
                options={[
                  { label: "Techbazaar", value: "Techbazaar" },
                  { label: "Leopard", value: "Leopard" },
                  { label: "Daewoo", value: "Daewoo" },
                  { label: "TCS", value: "TCS" },
                  { label: "TRAX", value: "TRAX" },
                  { label: "PostEX", value: "PostEX" },
                ]}
                handleChange={(e) => handleSelectChange(e, "name")}
                disabled={edit}
              />
              <Form.Control value={customForm?.name} onChange={() => {}} hidden required />
              <Form.Control.Feedback type="invalid">Please select name.</Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col className="py-3" md={6}>
            <Form.Group>
              <SearchableSelect
                placeholder="Select"
                label="Type"
                value={customForm.type}
                searchable={true}
                options={[
                  { label: "Self", value: "Self" },
                  { label: "Third Party", value: "Third Party" },
                ]}
                handleChange={(e) => handleSelectChange(e, "type")}
                disabled={edit}
              />
              <Form.Control value={customForm?.type} onChange={() => {}} hidden required />
              <Form.Control.Feedback type="invalid">Please select Type.</Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col className="py-3" md={12}>
            <Form.Group>
              <Form.Label>
                Tracking URL <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control type="url" name="tracking_url" value={customForm.tracking_url} onChange={handleChange} placeholder="Enter Tracking URL" required />
              <Form.Control.Feedback type="invalid">Please enter valid tracking URL.</Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>

        <Row className="py-3">
          <Col>
            <Button type="submit" className="w-100">
              Save
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default DeliveryPartnerModal;
